import { Component, OnInit } from '@angular/core';
import { StorageService } from './../../services/storage.service';
import { EleicaoService } from 'src/app/services/eleicao.service';
import { CanditadosService } from 'src/app/services/canditados.service';
import { Eleicao } from 'src/app/models/eleicao.model';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-initial',
  templateUrl: './initial.component.html'
})
export class InitialComponent implements OnInit {

  eleicao: Eleicao;
  dataInicio: Date = new Date();
  votacaoAberta: number = 1;
  role: any;

  constructor(
    protected candidatoService: CanditadosService,
    protected eleicaoService: EleicaoService,
    protected storage: StorageService,
    protected router: Router,
    public route: ActivatedRoute,
  ) { }

  ngOnInit() {
    this.route.params.subscribe(async params => {
      if (params.rotaEleicao && params.rotaEleicao != "gestor" && params.rotaEleicao != "admin" ) {
        this.getLogo(params.rotaEleicao);
      }
    });
  }
  
  async getLogo(rota: string) {
    try {
      const request = await this.eleicaoService.getLogoByRotaEleicao(rota).toPromise();
      if (request) {
        this.eleicaoService.logoEleicao = request;
        sessionStorage.setItem('logoEleicao', request);
      }
    } catch( error ) {
      console.log( error );
    }
  }

  /* INSTANCIANDO A ELEIÇÃO COM ID ( 1 )*/
  // public getEleicaoPorId(id: number = 1) {
  //   this.eleicaoService.getById(id).subscribe(result => {
  //     this.eleicao = result;
  //    // this.getValidaDataHoraEleicao(this.eleicao.dataHoraInicio.toString());   

  //   })
  // }

  // public getValidaDataHoraEleicao(dataAtual: string) {
  //   let dataValidaEleicao: string;
  //   let dia = this.dataInicio.getDate();
  //   let mes = this.dataInicio.getMonth() + 1;
  //   let ano = this.dataInicio.getFullYear();
  //   let hora = this.dataInicio.getHours();
  //   let minuto = this.dataInicio.getMinutes();
  //   let segundo = this.dataInicio.getSeconds();

  //   //fazendo correção do Zero a esquerda de 0 a 9
  //   function format_time(time) {
  //     if (time >= 0 && time <= 9) {
  //       var formatted_time = time.toString();
  //       formatted_time = "0" + formatted_time;
  //     } else {
  //       var formatted_time = time.toString();
  //     }
  //     return formatted_time
  //   }

  //   dataValidaEleicao = format_time(dia) + '/' + format_time(mes) + '/' + format_time(ano) + ' ' + format_time(hora) + ':' + format_time(minuto) + ':' + format_time(segundo);
  //   if (dataValidaEleicao <= dataAtual && dataValidaEleicao < this.eleicao.dataHoraFim.toString()) {
  //     this.votacaoAberta = 2; //ABERTO
  //   } else {
  //     this.votacaoAberta = 1; //FECHADO
  //   }
  // }



  /*#####  CRONOMETRO  #####*/


}

